import { fallbackCopy, newVector, newSize, newTextPinComponent } from '../helpers';
import { newCategoryAreaPinComponent } from '../helpers/pin-components/category-area-pin-component';
import { AnswerByCategoryPinLayoutTemplate, CATEGORY_LAYOUT_PERCENTAGES, LU_PIN_DIMENSIONS } from '../models';
import { stringToLeanProsemirror, stringToProsemirror } from '../tip-tap';

const FULL_WIDTH = LU_PIN_DIMENSIONS.width;
const FULL_HEIGHT = LU_PIN_DIMENSIONS.height;

const MARGIN_PX = (CATEGORY_LAYOUT_PERCENTAGES.MARGIN / 100) * FULL_WIDTH;
const CATEGORY_WIDTH_PX = (CATEGORY_LAYOUT_PERCENTAGES.WIDTH / 100) * FULL_WIDTH;
const CATEGORY_HEIGHT_PX = (CATEGORY_LAYOUT_PERCENTAGES.HEIGHT / 100) * FULL_HEIGHT;

export function answerByCategoryTitleOnlyLayout({
  question = fallbackCopy['answerByCategory.title'],
  categoryOne = fallbackCopy['answerByCategory.category1'],
  categoryTwo = fallbackCopy['answerByCategory.category2'],
  backgroundColor,
  backgroundImage,
}: {
  question?: string;
  categoryOne?: string;
  categoryTwo?: string;
  backgroundColor?: string;
  backgroundImage?: string;
}): AnswerByCategoryPinLayoutTemplate {
  return {
    key: 'TITLE_ONLY',
    backgroundColor,
    backgroundImage,
    pinComponents: [
      newCategoryAreaPinComponent({
        position: newVector(0, 0),
        size: newSize(FULL_WIDTH, FULL_HEIGHT),
        order: 'a0',
        settings: {
          layoutMode: 'AUTO',
          categories: [
            {
              id: 'category-1',
              text: stringToLeanProsemirror(categoryOne),
              layout: {
                type: 'BOX',
                position: { x: MARGIN_PX / 2, y: MARGIN_PX },
                size: {
                  width: CATEGORY_WIDTH_PX,
                  height: CATEGORY_HEIGHT_PX,
                },
                rotation: 0,
              },
            },
            {
              id: 'category-2',
              text: stringToLeanProsemirror(categoryTwo),
              layout: {
                type: 'BOX',
                // We place the second category to the right of the first one, with a margin between them.
                // The idea is that the default custom grid can fit 3 x 2 categories without the user having to make adjustments.
                position: { x: MARGIN_PX * 1.5 + CATEGORY_WIDTH_PX, y: MARGIN_PX },
                size: {
                  width: CATEGORY_WIDTH_PX,
                  height: CATEGORY_HEIGHT_PX,
                },
                rotation: 0,
              },
            },
          ],
        },
      }),
    ],
    layoutParts: {
      TITLE: newTextPinComponent({
        // We center the title in the middle of the screen.
        position: newVector(32, FULL_HEIGHT / 2 - 30),
        size: newSize(896, 60),
        content: stringToProsemirror(question, {
          bold: true,
        }),
        order: 'a1',
        settings: {
          typographyKey: 'headline',
          textStyleKey: 'TITLE',
          horizontalAlignment: 'center',
          verticalAlignment: 'center',
        },
      }),
    },
  };
}
